import { useAppDispatch, useAppSelector } from "Redux/hooks";
import { fetchUnassignedUsers } from "feature/admin/actions";
import {
  selectChecked,
  selectLoadingUnassignedUser,
  selectUnassignedSelectedUsers,
  selectUnassignedUsers,
  toggleAllUnassignedUsers,
  toggleUnassignedUserSelection,
} from "feature/admin/slice";
import { User } from "feature/admin/types";
import { useEffect } from "react";
import UserTable from "./components/UserTable";
import useCheckbox from "./hooks/useCheckbox";

const UnassignedUsers = () => {
  const dispatch = useAppDispatch();
  const unassignedUsers = useAppSelector(selectUnassignedUsers);
  const loadingUnassignedUsers = useAppSelector(selectLoadingUnassignedUser);
  const selectedUsers = useAppSelector(selectUnassignedSelectedUsers);
  const checked = useAppSelector(selectChecked);
  const checkbox = useCheckbox<User>({
    items: unassignedUsers,
    selectedItems: selectedUsers,
    checked,
  });

  const toggleAllHandler = () => {
    dispatch(toggleAllUnassignedUsers());
  };

  useEffect(() => {
    dispatch(fetchUnassignedUsers());
  }, []);

  const toggleUserSelectionHandler = (user: User, checked: boolean) => {
    dispatch(toggleUnassignedUserSelection({ user, checked }));
  };
  return (
    <UserTable
      title={"Unassigned Users"}
      users={unassignedUsers}
      isLoading={loadingUnassignedUsers}
      toggleAllHandler={toggleAllHandler}
      selectedUsers={selectedUsers}
      toggleUserSelectionHandler={toggleUserSelectionHandler}
      checkbox={checkbox}
      checked={checked}
      canMoveUsers
    />
  );
};

export default UnassignedUsers;
